import { Container, Row, Col} from "react-bootstrap"

export const Footer=()=>{
    return(
    <footer className="footer">
        <Container>
            <Row>
                <Col size={6} sm={12} className=" text-sm-end">
                {/* <img src={logo} alt="Logo" /> */}
                    <p>Built with 💖 by Suzan Dsouza</p>
                </Col>
                {/* <Col size={12} sm={6} className="text-center text-sm-end">
                    <div className="social-icon">
                        <a href=""><img src="https://cdn-icons-png.flaticon.com/512/25/25231.png"></img></a>
                        <a><img src="https://img.icons8.com/ios-glyphs/512/linkedin-circled.png"></img></a>
                    </div>
                </Col> */}
            </Row>
        </Container>
    </footer>
    )
}